<template>
  <div class="banner border-radius-8" v-if="banner">
    <router-link :to="banner.href" class="item-wrap banner-item">
      <lazy-img width="100%" height="100%" background="transparent" :src="banner.imgUrl"></lazy-img>
    </router-link>
  </div>
</template>

<script>
import { resolveActionPath } from "../../../util/function";
import lazyImg from "../../../components/lazy-img";

export default {
  name: "banner",
  data() {
    return {
      dheight: "0"
    };
  },
  computed: {
    banner() {
      return this.$store.state.home.bannerList.map(item => {
        return {
          id: item.bannerId,
          href: resolveActionPath(item),
          title: item.name,
          imgUrl: item.imgUrl
        };
      })[0];
    }
  },
  mounted() {
    const self = this;
    const [doc, win] = [document, window];
    let docEle = doc.documentElement,
      evt = "onorientationchange" in window ? "orientationchange" : "resize",
      fn = function() {
        const width = docEle.clientWidth;
        width && (self.dheight = (97.5 / 375) * width + "px");
      };
    win.addEventListener(evt, fn, false);
    fn();
  },
  components: {
    "lazy-img": lazyImg
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  // background: linear-gradient(
  //   to bottom,
  //   rgb(255, 255, 255) 20%,
  //   rgb(247, 247, 247)
  // );
  overflow: hidden;
  list-style: none;
  margin-bottom: 10px;
  .banner-item {
    display: block;
    margin: auto;
    width: 100%;
    height: calc(~"( 170 / 750 ) * 100vw");
  }
}
</style>
